// extracted by mini-css-extract-plugin
module.exports = {"Traks":"Traks_Traks__3f0wk"};